// @ts-nocheck
// Other
import { inject, observer } from 'mobx-react'
import React, { memo, useEffect, useState } from 'react'
import { WorkPageWrapper } from '../ManagementAssetWarehouseStylePage'
import DashboardLayout from '../../../layouts/DashboardLayout'
import { Helmet } from 'react-helmet'
import PageTitle from '../../../components/PageTitle'
import AppPageHeader from '../../../components/AppPageHeader'
import AccessControlAction from '../../../components/AccessControlAction'
import { Button, DatePicker, Menu, message } from 'antd'
import {
  FileExcelOutlined,
  VerticalAlignMiddleOutlined,
} from '@ant-design/icons'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import ContentBlockWrapper from '../../../components/ContentBlockWrapper'
import AssetStatisticsTable from './AssetStatisticsTable'
import moment from 'moment'
import queryString from 'query-string'
import { useLocation, withRouter } from 'react-router-dom'
import { exportAssetStatisticsExcel } from './ExportAssetStatisticExcel'

const AssetStatisticsPage = props => {
  const { managementAssetWarehouseStore, authenticationStore, history } = props
  const { isAccountAdmin, currentUser } = authenticationStore
  const [isDisplaySummary, setIsDisplaySummary] = useState(false)
  const [isLoadingSummary, setIsLoadingSummary] = useState(false)
  const [currentDate, setCurrentDate] = useState(
    moment(new Date()).format('MM-YYYY')
  )
  const location = useLocation()
  const queryStringParse = queryString.parse(location.search)
  const [isLoading, setIsLoading] = useState(false)
  const { pageIndex, sizeIndex } = managementAssetWarehouseStore

  useEffect(() => {
    ;(async () => {
      await managementAssetWarehouseStore.clearFilter()
    })()
  }, [])
  useEffect(() => {
    if (queryStringParse.currentDate) {
      setCurrentDate(queryStringParse.currentDate)
    }
    if (queryStringParse.page > 0) {
      managementAssetWarehouseStore.setFilter(
        'pageIndex',
        queryStringParse.page
      )
    }
  }, [])
  useEffect(() => {
    if (isAccountAdmin) {
      setIsDisplaySummary(true)
    } else {
      setIsDisplaySummary(false)
    }
  }, [isAccountAdmin, currentUser])

  const handleChangeParams = params => {
    const queryStringStringify = queryString.stringify({
      ...queryStringParse,
      // page: 0,
      size: 10,
      ...params,
    })
    history.replace(`/manager-inventory/statistic?${queryStringStringify}`)
  }

  const onChange = (date, dateString) => {
    setCurrentDate(dateString)
    handleChangeParams({ currentDate: dateString })
  }

  const exportAssetStatisticExcel = async () => {
    try {
      await managementAssetWarehouseStore.getAssetStatisticListExcel({
        monthYear: currentDate,
        page: 0,
        size: 999999,
      })

      await exportAssetStatisticsExcel(
        managementAssetWarehouseStore.assetStatisticListExcel,
        currentDate
      )
    } catch (error) {
      console.log(error)
    }
  }

  const summary = async () => {
    try {
      const startValue = moment(new Date()).format('MM-YYYY')
      if (currentDate == startValue || isAccountAdmin) {
        setIsLoadingSummary(true)
        await managementAssetWarehouseStore.summary({
          monthYear: currentDate,
        })
        loadManagerInventoryList()
      } else {
        message.error('không thể tổng hợp tháng trước')
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoadingSummary(false)
    }
  }

  useEffect(() => {
    ;(async () => {
      await loadManagerInventoryList()
    })()
  }, [pageIndex, sizeIndex, currentDate])

  const loadManagerInventoryList = async () => {
    try {
      setIsLoading(true)
      await managementAssetWarehouseStore.getAssetStatisticList({
        monthYear: currentDate,
      })
    } catch (e) {
      console.log(e)
    } finally {
      setIsLoading(false)
    }
  }
  return (
    <WorkPageWrapper>
      <DashboardLayout>
        <Helmet>
          <title>Hành chính | Quản lý kho | Tài sản</title>
        </Helmet>

        <AppPageHeader
          title="Thống kê tài sản"
          addon={
            <AccessControlAction check={true}>
              <>
                <DatePicker
                  onChange={onChange}
                  className="h-40"
                  picker="month"
                  format="MM-YYYY"
                  defaultValue={moment(currentDate, 'MM-YYYY')}
                  style={{ width: '220px' }}
                />
                {isDisplaySummary && (
                  <Button
                    className="custom-ant-button"
                    loading={isLoadingSummary}
                    onClick={() => summary()}>
                    Tổng kết
                  </Button>
                )}
                <Button
                  className="custom-ant-button"
                  onClick={() => exportAssetStatisticExcel()}>
                  Xuất excel
                </Button>
              </>
            </AccessControlAction>
          }
        />
        <ContentBlockWrapper>
          <Menu
            className="custom-menu-tab"
            mode="horizontal"
            selectedKeys={[props.location?.pathname]}
            style={{ marginBottom: 16 }}>
            <Menu.Item key="/manager-inventory/inventory-asset">
              <Link to={'/manager-inventory/inventory-asset'}>Tài sản</Link>
            </Menu.Item>

            <Menu.Item key="/manager-inventory/manage-inventory-asset">
              <Link to={'/manager-inventory/manage-inventory-asset'}>
                Loại văn phòng phẩm
              </Link>
            </Menu.Item>

            <Menu.Item key="/manager-inventory/statistic">
              <Link to={'/manager-inventory/statistic'}>
                Thống kê tài sản tháng {currentDate}
              </Link>
            </Menu.Item>

            <Menu.Item key="/manager-inventory/export-statistic">
              <Link to={'/manager-inventory/export-statistic'}>
                Báo cáo sử dụng văn phòng phẩm theo tháng {currentDate}
              </Link>
            </Menu.Item>
          </Menu>

          <AssetStatisticsTable
            isLoading={isLoading}
            currentDate={currentDate}
            handleChangeParams={handleChangeParams}
          />
        </ContentBlockWrapper>
      </DashboardLayout>
    </WorkPageWrapper>
  )
}

export default memo(
  withRouter(
    inject(
      'managementAssetWarehouseStore',
      'authenticationStore'
    )(observer(AssetStatisticsPage))
  )
)
